module.exports = __webpack_public_path__ + "img/img2.9d9e2930.jpg";